import React, { useState, useEffect } from "react";
import {
    Table,
    Button,
    Input,
    Modal,
    Spin,
    Row,
    Col,
    Tooltip,
    Popconfirm,
    Select
} from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import apiRequest from "../hooks/ApiRequest";
import HomeLayout from "../components/Layouts";
import { toast } from "react-toastify";

const { Option } = Select;

const ManageDocumentMapping = () => {
    const staticModules = [
            { moduleId: 102, name: "Quotation" },
            { moduleId: 103, name: "Claim" },
            { moduleId: 106, name: "Policy" }
        ];
    const [loading, setLoading] = useState(false);
    const [mappings, setMappings] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedMapping, setSelectedMapping] = useState(null);

    // dropdown data
    const [documents, setDocuments] = useState([]);
    const [products, setProducts] = useState([]);
    const [modules, setModules] = useState([]);


    const [formData, setFormData] = useState({
        documentMasterId: null,
        productId: null,
        moduleId: null,
        active: true
    });

    const insurerId = localStorage.getItem("insurerId");
    const role = localStorage.getItem("roles");

    useEffect(() => {
         fetchModules();
        fetchMappings();
        fetchDocuments();
        fetchProducts();
       
    }, []);


    const fetchMappings = async () => {
        setLoading(true);
        try {
            const response = await apiRequest(
                `${process.env.REACT_APP_BASE_URL_DOCUMENT}/ModuleDocument`,
                "GET"
            );
            const actualData = response.data?.data || response.data;
            debugger;
            const updatedActualData = actualData.map(user => {
                const moduleName =
                    staticModules?.find(mod => mod.moduleId == user.moduleId)?.name ||
                    user.moduleId;

                return { ...user, moduleName };
            });


            setMappings(Array.isArray(updatedActualData) ? updatedActualData : []);
        } catch (error) {
            toast.error("Error fetching mappings");
        } finally {
            setLoading(false);
        }
    };

    const fetchDocuments = async () => {
        try {
            const res = await apiRequest(
                `${process.env.REACT_APP_BASE_URL_DOCUMENT}/DocumentMaster`,
                "GET"
            );
            setDocuments(res.data?.data || []);
        } catch (err) {
            toast.error("Failed to load documents");
        }
    };

    const fetchProducts = async () => {
        try {
            const res = await apiRequest(
                `${process.env.REACT_APP_BASE_URL_ADMIN}/Product/GetAllProducts`,
                "GET"
            );

            if (res?.data?.data && Array.isArray(res.data.data)) {
                setProducts(res.data.data);
            } else {
                setProducts([]);
                toast.error("No products found");
            }
        } catch (err) {
            toast.error("Failed to load products");
        }
    };




    const fetchModules = () => {
        
        setModules(staticModules);
    };


    const handleCreate = () => {
        setSelectedMapping(null);
        setFormData({
            documentMasterId: null,
            productId: null,
            moduleId: null,
            active: true
        });
        setModalVisible(true);
    };

    const handleEdit = (record) => {
        setSelectedMapping(record);
        setFormData({
            documentMasterId: record.documentMasterId,
            productId: record.productId,
            moduleId: record.moduleId,
            active: record.active
        });
        setModalVisible(true);
    };

    const handleDelete = async (id) => {
        try {
            const response = await apiRequest(
                `${process.env.REACT_APP_BASE_URL_DOCUMENT}/ModuleDocument/delete/${id}`,
                "POST"
            );
            if (response.success) {
                toast.success("Mapping deleted");
                fetchMappings();
            } else {
                toast.error(response.message || "Delete failed");
            }
        } catch (error) {
            toast.error("Error deleting mapping");
        }
    };

    const handleSave = async () => {
        try {

            const userId = localStorage.getItem("loggedInUserID");
            const role = localStorage.getItem("roles");

            const payload = {
                id: selectedMapping ? selectedMapping.id : 0,
                moduleId: formData.moduleId,
                productId: formData.productId,
                documentMasterId: formData.documentMasterId,
                insurerId: parseInt(userId),
                required: formData.required || false,
                active: formData.active,
                createdBy: selectedMapping ? selectedMapping.createdBy : role,
                createdAt: selectedMapping ? selectedMapping.createdAt : new Date().toISOString(),
                modifiedBy: role,
                modifiedAt: new Date().toISOString(),
            };

            console.log("Payload before save:", payload);

            let url = `${process.env.REACT_APP_BASE_URL_DOCUMENT}/ModuleDocument`;
            if (selectedMapping) {
                url = `${process.env.REACT_APP_BASE_URL_DOCUMENT}/ModuleDocument/update/${selectedMapping.id}`;
            }

            const response = await apiRequest(url, "POST", payload);

            if (response.success) {
                toast.success(selectedMapping ? "Module Document updated" : "Module Document created");
                fetchMappings();
                setModalVisible(false);
            } else {
                toast.error(response.message || "Save failed");
            }
        } catch (error) {
            console.error("Save error:", error);
            toast.error("Error saving module document");
        }
    };


    const columns = [
        { title: "Document", dataIndex: "documentName", key: "documentName" },
        {
            title: "Product", dataIndex: "productId", key: "productId",
            render: (id) => {
                const product = products.find((p) => p.productid === id);
                return product ? product.productname : id;
            },
        },
        {
            title: "Module",
            dataIndex: "moduleName",
            key: "moduleName"
        },
        { title: "Active", dataIndex: "active", key: "active", render: (val) => (val ? "Yes" : "No") },
        {
            title: "Actions",
            key: "actions",
            render: (_, record) => (
                <>
                    <Tooltip title="Edit">
                        <Button type="primary" onClick={() => handleEdit(record)}>
                            <EditOutlined />
                        </Button>
                    </Tooltip>
                    <Popconfirm
                        title="Are you sure to delete this mapping?"
                        onConfirm={() => handleDelete(record.id)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Tooltip title="Delete">
                            <Button type="danger" style={{ marginLeft: 8 }}>
                                <DeleteOutlined />
                            </Button>
                        </Tooltip>
                    </Popconfirm>
                </>
            ),
        },
    ];

    return (

        <div className="ant-layout-content dashboard">
            <div className="dash-bg-white">
                <Row gutter={[16, 16]} align="middle">
                    <Col xs={24} sm={24} md={12} lg={8}>
                        <h3 style={{ color: "#0C1362", fontWeight: "600", fontSize: "20px" }}>
                            Manage Document Mapping
                        </h3>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={8}>
                        <Button type="primary" onClick={handleCreate}>
                            Add Mapping
                        </Button>
                    </Col>
                </Row>
            </div>

            {loading ? (
                <Spin size="large" style={{ marginTop: 20 }} />
            ) : (
                <Table columns={columns} dataSource={mappings} rowKey="id" />
            )}

            <Modal
                title={selectedMapping ? "Edit Mapping" : "Add Mapping"}
                centered
                visible={modalVisible}
                footer={null}
                onCancel={() => setModalVisible(false)}
                width={600}
            >
                <div>
                    <label style={{ fontWeight: "bold" }}>Document:</label>
                    <Select
                        value={formData.documentMasterId}
                        onChange={(value) => setFormData({ ...formData, documentMasterId: value })}
                        placeholder="Select Document"
                        style={{ width: "100%", marginBottom: "15px" }}
                    >
                        {documents.map((doc) => (
                            <Option key={doc.id} value={doc.id}>
                                {doc.name}
                            </Option>
                        ))}
                    </Select>

                    <label style={{ fontWeight: "bold" }}>Product:</label>
                    <label style={{ fontWeight: "bold" }}>Product:</label>
                    <Select
                        value={formData.productId}
                        onChange={(value) => setFormData({ ...formData, productId: value })}
                        placeholder="Select Product"
                        style={{ width: "100%", marginBottom: "15px" }}
                    >
                        {products.map((p) => (
                            <Option key={p.productid} value={p.productid}>
                                {p.productname}
                            </Option>
                        ))}
                    </Select>


                    <label style={{ fontWeight: "bold" }}>Module:</label>
                    <Select
                        value={formData.moduleId}
                        onChange={(value) => setFormData({ ...formData, moduleId: value })}
                        placeholder="Select Module"
                        style={{ width: "100%", marginBottom: "15px" }}
                    >
                        {modules.map((mod) => (
                            <Option key={mod.moduleId} value={mod.moduleId}>
                                {mod.name}
                            </Option>
                        ))}
                    </Select>


                    <Button type="primary" onClick={handleSave}>
                        {selectedMapping ? "Update" : "Create"}
                    </Button>
                </div>
            </Modal>

        </div>

    );
};

export default ManageDocumentMapping;
